import React from 'react';
import { DateTime } from 'luxon';
import { DATE_FORMAT } from '../../../utils/dateUtils';

export const DateCell = ({ dateValue }: { dateValue: string | null | undefined }) => {
  if (!dateValue) {
    return <span>---</span>; // Return fallback text if the date is missing
  }

  const formattedDate = DateTime.fromISO(dateValue).toFormat(DATE_FORMAT);

  return <span>{formattedDate}</span>;
};
